import {ChangeDetectionStrategy, Component, Injectable, signal} from "@angular/core";
import {KeyValuePipe} from "@angular/common";
import {AsynkOppgaveModell, AsynkOppgaveRessursClient, Status} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {FormaterZonedDateTimePipe} from "felles-ng2/pipes/FormaterZonedDateTimePipe";
import {TranslateModule} from "@ngx-translate/core";
import {AdministrasjonNavigasjonKomponent} from '../administrasjon-navigasjon/administrasjon-navigasjon';

@Component({
    selector: 'administrasjon-asynk-oppgaver',
    templateUrl: 'asynk-oppgaver.html',
    styleUrl: 'asynk-oppgaver.scss',
    host: {'data-testid': 'administrasjon-asynk-oppgaver'},
    imports: [FormaterZonedDateTimePipe, TranslateModule, KeyValuePipe, AdministrasjonNavigasjonKomponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AdministrasjonAsynkOppgaverKomponent {
    static ajsSelector = 'administrasjonAsynkOppgaver';

    readonly statuser = [Status.ikke_påbegynt, Status.påbegynt, Status.feilet, Status.avsluttet, Status.parkert];
    readonly aktivtFilter = signal<Status>(Status.avsluttet);
    readonly oppgaver = signal<AsynkOppgaveModell[]>([]);

    constructor(private avhengigheter: AdministrasjonAsynkOppgaverAvhengigheter) {
        this.lastInn();
    }

    filterEndret(status: Status) {
        this.aktivtFilter.set(status);
        this.lastInn();
    }

    async kjorIgjen(oppgave: AsynkOppgaveModell) {
        const oppdatert = await this.avhengigheter.kjorIgjen(oppgave.id);
        this.oppgaver.update(oppgaver => oppgaver.map(o => o.id === oppgave.id ? oppdatert : o));
    }

    async parker(oppgave: AsynkOppgaveModell) {
        const oppdatert = await this.avhengigheter.parker(oppgave.id);
        this.oppgaver.update(oppgaver => oppgaver.map(o => o.id === oppgave.id ? oppdatert : o));
    }

    statusTekst(status: Status): string {
        switch (status) {
            case Status.ikke_påbegynt: return 'Ikke påbegynt';
            case Status.påbegynt: return 'Påbegynt';
            case Status.feilet: return 'Feilet';
            case Status.avsluttet: return 'Avsluttet';
            case Status.parkert: return 'Parkert';
        }
    }

    private async lastInn() {
        this.oppgaver.set(await this.avhengigheter.hentAlle(this.aktivtFilter()));
    }
}

@Injectable({providedIn: 'root'})
export class AdministrasjonAsynkOppgaverAvhengigheter {
    constructor(private ressurs: AsynkOppgaveRessursClient) {}

    hentAlle(status: Status): Promise<AsynkOppgaveModell[]> {
        return this.ressurs.hentAlle({statusFilter: status}).somPromise();
    }

    kjorIgjen(id: string): Promise<AsynkOppgaveModell> {
        return this.ressurs.restartJobb(id).somPromise();
    }

    parker(id: string): Promise<AsynkOppgaveModell> {
        return this.ressurs.parkerJobb(id).somPromise();
    }
}
